import { type Colors, IconBackArrow24, Role, Typography, useTheme } from '@copybet/wui';
import { type ReactNode, useCallback, useEffect } from 'react';
import styled from '@emotion/styled';

type WidgetStackWrapperProps = {
  backgroundColor?: keyof Colors;
};

const WidgetStackWrapper = styled.div<WidgetStackWrapperProps>`
  position: fixed;
  z-index: 3000;
  top: var(--crawl-banner-height, 0px);
  left: 0;
  right: 0;
  bottom: 0;
  padding: 16px;
  background-color: ${({ backgroundColor, theme }) => (backgroundColor ? theme.colors[backgroundColor] : theme.colors.$ui01)};
  overflow: scroll;
  h1 {
    margin-left: -24px;
  }
`;

const WidgetStackHeading = styled.div`
  height: 24px;
  margin-bottom: 16px;
`;

const WidgetStackHeadingButton = styled.button`
  background-color: transparent;
  border: none;
`;

type WidgetStackProps = {
  children: ReactNode;
  title: string;
  goBack?: () => void;
  backgroundColor?: keyof Colors;
};

export const WidgetStack = ({ children, title, goBack, backgroundColor }: WidgetStackProps) => {
  const { colors } = useTheme();

  const handleGoBack = useCallback(() => {
    if (goBack) {
      return goBack();
    }
    window.history.back();
  }, [goBack]);

  // hack for Safari not to show underlining scroll for pages using this widget
  useEffect(() => {
    if (typeof document === 'undefined') return;

    document.body.style.overflow = 'hidden!important';
    return () => {
      document.body.style.overflow = 'scroll';
    };
  }, []);

  // useEffect(() => {
  //   const preventDefault = (e: TouchEvent): void => e.preventDefault();
  //   document.addEventListener('touchmove', preventDefault, { passive: false });

  //   return () => {
  //     document.removeEventListener('touchmove', preventDefault);
  //   };
  // }, []);

  return (
    <WidgetStackWrapper backgroundColor={backgroundColor}>
      <WidgetStackHeading className="d-flex flex-row flex-nowrap justify-content-center align-items-center">
        <Role name="back">
          <WidgetStackHeadingButton onClick={handleGoBack} className="me-auto">
            <IconBackArrow24 fill={colors.$label01} />
          </WidgetStackHeadingButton>
        </Role>
        <Role name="title">
          <Typography as="h1" variant="$button01" className="me-auto">
            {title}
          </Typography>
        </Role>
      </WidgetStackHeading>
      {children}
    </WidgetStackWrapper>
  );
};
